<template>
    <div class="historical-section">
        <div>
            <div class="mt-4 mb-8">
                Upon seller’s approval, additional detail will be provided for the subject practice to ensure proper due diligence can be conducted.
            </div>
            <div class="info-wrapper">
                <CustomIcon name="srg-lightbulb" color="white" width="45" height="45" />
                <span>{{ recurringPercent }}% Recurring Revenue</span>
            </div>
        </div>

        <div class="graph-wrapper">
            <h3 class="text-center grey--text text--darken-2">Historical Revenue</h3>
            <HistoricalGraph
                :historicalRevenue="historicalRevenue"
                :tasof="listing.revenue_t12_asof_date"
            />
            <div class="text-center body-2 grey--text text--darken-1" v-if="listing.revenue_t12_asof_date">* {{asOfDate}}</div>
        </div>
    </div>
</template>

<script>
    import HistoricalGraph from './HistoricalGraph'

    export default {
        name: 'DetailsRevenueHistorical',
        
        components: {
            HistoricalGraph,
        },
        
        props: {
            recurringPercent: {
                type: String,
                default: '0',
            },
            historicalRevenue: {
                type: Array,
                default: () => [],
            },
            listing: {
                type: Object,
                default: () => {}
            }
        },

        computed: {
            // startYear () {
            //   if ((this.historicalRevenue[0] || {}).year !== 0 ) {
            //     return (this.historicalRevenue[0] || {}).year;
            //   } else {
            //     return (this.historicalRevenue[1] || {}).year;
            //   }
            // },
            // endYear () {
            //   const length = this.historicalRevenue.length
            //   return (this.historicalRevenue[length - 1] || {}).year
            // },
            asOfDate() {
                const date = this.listing.revenue_t12_asof_date;
                return 'As of ' + date;
            },
        },
}
</script>

<style scoped>
.historical-section {
    /* padding: 20px 0 0 0; */
    display: grid;
    grid-template-columns: 1fr 450px;
    grid-template-rows: 320px;
    grid-column-gap: 10px;
    background-color: #EFEFEF;
}

p {
    padding: 10px;
}

.info-wrapper {
    height: 50px;
    width: 250px;

    display: flex;
    align-items: center;

    background-color: #97C131;
}

.info-wrapper svg {
    margin-top: -10px;
    margin-right: -10px;
}

.info-wrapper span {
    flex-grow: 1;

    color: white;
    font-family: "SansationBold", sans-serif;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}

.graph-wrapper {
    padding: 15px 10px 0;

    border-radius: 4px;
    /* background-color: #F2F2F2; */
    background-color: #EFEFEF;
}

.graph-wrapper,
.graph-wrapper >>> div {
    height: 100%;
}

.graph-wrapper h3 {
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-revenue/RevenueHistorical.vue